import {param, deparam} from 'nutshell-core/routing/query-parameters';

export const updateSearchWithMultipleNewFilters = (
    filters: Array<{
        filterKey: string;
        entityId: string;
    }>,
    search: string,
    validFilterKeys: string[]
) => {
    if (!filters || filters.length === 0) {
        return search;
    }

    const areAllFiltersValid = filters.every(({filterKey}) => validFilterKeys.includes(filterKey));
    if (!areAllFiltersValid) {
        return search;
    }

    // remove ? before search string
    let newSearch = search.slice(1);

    newSearch = deparam(search);
    // @ts-expect-error
    const searchFilter = newSearch.filter;
    const filterKeysInSearch = Object.keys(searchFilter);

    // remove all existing filters from searchFilter, preserving 'period'
    filterKeysInSearch
        .filter((key) => key !== 'period')
        .forEach((key) => {
            delete searchFilter[key];
        });

    // add all new filters
    filters.forEach(({filterKey, entityId}) => {
        searchFilter[filterKey] = [entityId];
    });

    // @ts-expect-error
    newSearch.filter = searchFilter;
    newSearch = param(newSearch);

    return newSearch;
};
